import { render, staticRenderFns } from "./Disc.vue?vue&type=template&id=5c5087d0&"
import script from "./Disc.vue?vue&type=script&lang=ts&"
export * from "./Disc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports